<template>
  <div class="auth">
    <div class="auth-background__icon">
      <img
        src="@/assets/images/auth/admin-background-icon.png"
        alt="background"
      />
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Auth'
}
</script>

<style lang="scss">
.auth {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #eef0f8;
  position: relative;
  &-background__icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 1;
    img {
      width: 1600px;
      position: absolute;
      top: 80%;
      left: 50%;
      transform: translate(-50%, -100%);
    }
  }
}
</style>
